var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { PoseAnswer } from './modules/PoseAnswer';
import { PoseEnforce } from './modules/PoseEnforce';
export class TrayPose {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
    get poseAnswer() {
        return new PoseAnswer(this);
    }
    get poseEnforce() {
        return new PoseEnforce(this);
    }
    get currentlyPosedAnswer() {
        return this.poseAnswer.currentlyPosedAnswer;
    }
}
__decorate([
    memoize
], TrayPose.prototype, "poseAnswer", null);
__decorate([
    memoize
], TrayPose.prototype, "poseEnforce", null);
